import { request } from 'd3-request';

import { parseHostname } from '@ta-interaktiv/parse-hostname';
import { socialNetworkNameReplacement } from './socialNetworkNameReplacement';

var API_SUBDOMAIN = 'm';

/**
 * Notifies the Newsnet Share Counter
 * @param articleId
 * @param shareTypeId
 */
function notifyNewsnetShareCounter(articleId, shareTypeId) {
  request('//' + API_SUBDOMAIN + '.' + parseHostname().publicationDomain + '/api/communities/' + articleId + '/counts/' + shareTypeId).post();
}

/**
 * Push social shares to Google Tag Manager Data Layer
 * @param articleId
 * @param url - The URL that is being shared
 * @param socialNetwork - Shared over twitter, facebook, mail?
 */
function notifyGoogleAnalytics(articleId, url, socialNetwork) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    article_id: articleId,
    event: 'Social',
    event_action: 'share',
    event_label: url,
    socialNetwork: socialNetworkNameReplacement[socialNetwork]
  });
}

/**
 * The default click handler will call the share counting REST API upon
 * clicking the buttons.
 * @param {string} articleId The ID of the article.
 * @param {Community} community A community object, as provided by the
 *   Newsnet API
 * @param {object} event The react event object.
 */
export function defaultClickHandler(articleId, community, event) {
  notifyNewsnetShareCounter(articleId, community['share_type_id']);
  notifyGoogleAnalytics(articleId, window.location.href.replace(window.location.search, '').replace(window.location.hash, ''), community.type);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-share-buttons/es/defaultShareButtonClickHandler.js
// module id = null
// module chunks = 